import { render, staticRenderFns } from "./emailTemplatesTable.vue?vue&type=template&id=924a7e96"
import script from "./emailTemplatesTable.vue?vue&type=script&lang=js"
export * from "./emailTemplatesTable.vue?vue&type=script&lang=js"
import style0 from "./emailTemplatesTable.vue?vue&type=style&index=0&id=924a7e96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports